import React from 'react';
import PropTypes from 'prop-types';

import './DevicesInfo.css';

import Spinner from '../common/Spinner/Spinner';
import DevicesTableRow from '../DevicesTableRow/DevicesTableRow';

const DevicesInfo = ({ devicesSetInfo, isDevicesSetsInfoLoading }) => {
	let devicesSetInfoWithPrimaryFirst = [];
	devicesSetInfo.forEach((deviceInfo) => {
		if (deviceInfo.isPrimary === true) {
			devicesSetInfoWithPrimaryFirst.unshift(deviceInfo);
		} else {
			devicesSetInfoWithPrimaryFirst.push(deviceInfo);
		}
	});

	return (
		<div className="devices-info-wrapper">
			<div className="premium-header">
				<div className="analytics-title">
					<i className="material-icons">devices</i>
					<span>DEVICES INFO</span>
				</div>
			</div>

			<div className="devices-body scrollbar-hidden">
				{isDevicesSetsInfoLoading ? (
					<div className="devices-info-spinner">
						<Spinner />
					</div>
				) : devicesSetInfo.length > 0 ? (
					<table className="premium-table">
						<thead>
							<tr>
								<th className="device-name-column">Device</th>
								<th className="battery-column">Battery</th>
								<th className="temperature-column">Temperature</th>
								<th className="provider-column">Provider</th>
								<th className="network-type-column">Network</th>
								<th className="signal-strength-column">Signal</th>
							</tr>
						</thead>
						<tbody>
							{devicesSetInfoWithPrimaryFirst.map((deviceInfo, i) => (
								<DevicesTableRow key={i} {...deviceInfo} />
							))}
						</tbody>
					</table>
				) : (
					<div className="empty-devices-state">
						<i className="material-icons">devices_other</i>
						<span>No Device Connected</span>
					</div>
				)}
			</div>
		</div>
	);
};

DevicesInfo.propTypes = {
	devicesSetInfo: PropTypes.array.isRequired,
	isDevicesSetsInfoLoading: PropTypes.bool.isRequired
};

export default React.memo(DevicesInfo);
